
import {Component, Vue, Watch} from 'vue-property-decorator'
import CourierInfo from '@/model/modules/CourierInfo'
import CourierService from '@/service/modules/CourierService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import UserGroupInfo from '@/model/modules/UserGroupInfo'
import FreightPriceService from '@/service/modules/FreightPriceService'
import FreightPriceInfo from '@/model/modules/FreightPriceInfo'
import axios from '@/axios'

@Component
export default class UserGroupFreightPriceEditor extends Vue {
  item: UserGroupInfo = new UserGroupInfo()
  showState: boolean = false
  dataLoadingState: boolean = false
  courierList: CourierInfo[] = []
  courierId: number = 0

  listLoadingState: boolean = false
  headerDefine: any = [
    {text: '数据ID', value: 'id'},
    {text: '区域编号', value: 'area'},
    {text: '重量段起始≥', value: 'weightMin'},
    {text: '重量段结束＜', value: 'weightMax'},
    {text: '运费', value: 'freight'},
    {text: '挂号费', value: 'registrationFee'},
    {text: '处理费', value: 'processingFee'},
    {text: '其他费', value: 'otherFee'},
    {text: '燃油费', value: 'fuelCosts'}
  ]

  queryLikeResult: BasePageableInfo<FreightPriceInfo> = new BasePageableInfo<FreightPriceInfo>()
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [{text: '20条/页', value: 20}, {text: '50条/页', value: 50}, {
    text: '200条/页',
    value: 200
  }, {text: '1000条/页', value: 1000}, {text: '2000条/页', value: 2000}]

  uploadPanelShowState: boolean = false
  uploadingState: boolean = false
  // @ts-ignore
  uploadUrl: string = window.$HOST + '/order/import_price'
  uploadHeaders: any = axios.defaults.headers

  mounted() {
    CourierService.list({}, 0, 99999)
      .then((result: BasePageableInfo<CourierInfo>) => {
        this.courierList = result.dataList
        this.courierId = this.courierList[0].id
      })
  }

  showEditor(item: UserGroupInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.showState = true
    this.loadAllData()
    // @ts-ignore
    this.uploadUrl = window.$HOST + '/order/import_price?groupId=' + this.item.id + '&channel=' + this.courierId
  }

  @Watch('pageSize')
  onPageSizeChanged() {
    this.loadAllData()
  }

  @Watch('courierId')
  onCourierIdChanged() {
    this.loadAllData()
    this.pageNum = 1
    // @ts-ignore
    this.uploadUrl = window.$HOST + '/order/import_price?groupId=' + this.item.id + '&channel=' + this.courierId
  }

  @Watch('pageNum')
  loadAllData() {
    this.listLoadingState = true
    FreightPriceService.list({courierId: this.courierId, groupId: this.item.id}, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<FreightPriceInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
      })
  }

  beforeUpload() {
    this.uploadingState = true
  }

  uploadSuccess() {
    this.loadAllData()
    this.uploadingState = false
    this.$notify({
      title: 'Excel上传结束',
      message: '上传成功'
    })
    // @ts-ignore
    this.$refs.uploader.clearFiles()
    this.uploadPanelShowState = false
  }
}
